const stylesheet = `

.react-jinke-music-player-main svg:active, .react-jinke-music-player-main svg:hover {
    color: #d4a039
}

.react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-handle, .react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-track {
    background-color: #d4a039;
    border-color: #b8862e
}

.react-jinke-music-player-main ::-webkit-scrollbar-thumb {
    background-color: #d4a039;
}

.react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-handle:active {
    box-shadow: 0 0 2px #d4a039
}

.react-jinke-music-player-main .audio-item.playing svg {
    color: #d4a039
}

.react-jinke-music-player-main .audio-item.playing .player-singer {
    color: #d4a039 !important
}

.react-jinke-music-player-main .rc-slider-rail {
    background-color: #2a2a27 !important
}

.react-jinke-music-player-main .lyric-btn {
    color: #e5ddd3 !important
}

.react-jinke-music-player-main .music-player-panel {
    color: #e5ddd3 !important
}

.react-jinke-music-player-main .lyric-btn-active svg {
    color: #d4a039 !important
}

.music-player-lyric {
    color: #d4a039 !important
}

.audio-lists-panel-content .audio-item.playing, .audio-lists-panel-content .audio-item.playing svg {
    color: #d4a039
}
.audio-lists-panel-content .audio-item:active .group:not(.player-delete) svg, .audio-lists-panel-content .audio-item:hover .group:not(.player-delete) svg {
    color: #d4a039
}

.progress-bar-content .audio-title a {
    color: #e5ddd3
}

.MuiCheckbox-colorSecondary.Mui-checked {
    color: #d4a039 !important
}
`
export default stylesheet
